import React from 'react'
import {Link} from 'react-router-dom';
import {CgShoppingCart} from "react-icons/cg";

export default function SecondaryButton({path,slug}) {
    return (
        <Link to={`/${path}/${slug}`}>
            <div className="btn btn-secondary hoverBtn ">
                <CgShoppingCart size={25}/>
            </div>
        </Link>
    )
}
